/**
 * Typed gold amounts for the Bank (lane AN, stream note 23: "Gold should just
 * be typed numbers"). The field takes whole gold; thousands separators and
 * spaces are fine ("1,250", "1 250"). The client refuses what the server
 * would refuse, with the same reasons in player words; the server still
 * decides (src/server/handlers/bank/bankValidation.ts).
 */

export type GoldDirection = 'deposit' | 'withdraw';

export type GoldAmountCheck =
  | { ok: true; amount: number }
  | { ok: false; empty: boolean; problem: string };

/** Formats a gold count the way the bank prints it ("1,250"). */
export function formatGoldCount(n: number): string {
  return Math.max(0, Math.floor(Number.isFinite(n) ? n : 0)).toLocaleString('en-US');
}

/** Reads a typed amount against what can move: the purse for a deposit, the vault for a withdrawal. */
export function checkGoldAmount(text: string, available: number, direction: GoldDirection): GoldAmountCheck {
  const raw = text.trim();
  if (!raw) return { ok: false, empty: true, problem: '' };
  const digits = raw.replace(/[\s,_]/g, '');
  if (!/^\d+$/.test(digits)) return { ok: false, empty: false, problem: 'Type a whole number of gold.' };
  const amount = Number(digits);
  if (!Number.isSafeInteger(amount)) return { ok: false, empty: false, problem: 'That is more gold than there is.' };
  if (amount <= 0) return { ok: false, empty: false, problem: 'Type at least 1 gold.' };
  if (amount > available) {
    const have = formatGoldCount(available);
    return { ok: false, empty: false, problem: direction === 'deposit' ? `You carry ${have} gold.` : `The vault holds ${have} gold.` };
  }
  return { ok: true, amount };
}
